import React, { useEffect, useState } from 'react'
import { closeBorrow, convertEthToUSD2, getBorrowInfo, viewShareBorrow } from '../../functions/lendingfunctions';
import { popupManager } from "../common/PopupManager";

export default function LendingPosition({ position, signer }) {
  const [positionData, setPositionData] = useState(null);
  const [unlockTime, setUnlockTime] = useState(null);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState('');
  async function handleWithdrawBorrow(){
    let id = Date.now();
    try{
      popupManager.addPopup({
          id: id,
          type: "message",
          message: `Closing Borrow Position`,
        });
        const response = await closeBorrow(await signer.getAddress(),position, signer)
         popupManager.removePopup(id);
         let successful_id = Date.now();
         popupManager.addPopup({
           id: successful_id,
           type: "success",
           message:
             "Transaction sent!",
         });
    }catch(e){
      popupManager.removePopup(id);
                popupManager.addPopup({
                  id: Date.now(),
                  type: "error",
                  message: e.toString(),
                  duration: 6000,
                });
      console.log(e)
    }
  }
  useEffect(() => {
    async function fetchBorrowInfo() {
      try {
        const response = await getBorrowInfo( await signer.getAddress(),position);
        const shareborrow = await viewShareBorrow(await signer.getAddress(),position );
        

        response.shareborrow = await convertEthToUSD2(Math.round(shareborrow*0.4*1000000)/1000000)
        // Handle images / symbols
        if (response.tokenAddress === '0xdAC17F958D2ee523a2206206994597C13D831ec7') {
          response.img = 'https://assets.coingecko.com/coins/images/325/standard/Tether.png';
          response.symbol = 'USDT';
        } else if (response.tokenAddress === '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48') {
          response.symbol = 'USDC';
          response.img = 'https://assets.coingecko.com/coins/images/6319/standard/usdc.png';
        } else {
          response.symbol = 'ETH';
          response.img = 'w';
        }

        setPositionData(response);

        // If there's an unlockTimestamp, store it as a Date
        if (response.unlockTimestamp) {
          const timestampSeconds = parseInt(response.unlockTimestamp, 10);
          const unlockDate = new Date(timestampSeconds * 1000);
          setUnlockTime(unlockDate);

          // If the current time is already past unlock time, set as unlocked immediately
          if (new Date() >= unlockDate) {
            setIsUnlocked(true);
          }
        }
      } catch (error) {
        console.error('Error fetching position:', error);
      }
    }
    fetchBorrowInfo();
  }, [signer, position]);

  useEffect(() => {
    if (!unlockTime) return; // no unlock time => skip

    // Update countdown every second
    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const unlockMs = unlockTime.getTime();
      const diff = unlockMs - now;

      if (diff <= 0) {
        // If time is up (or in the past), unlock
        setIsUnlocked(true);
        setTimeRemaining('0d 0h 0m 0s');
        clearInterval(intervalId);
      } else {
        // Calculate days, hours, minutes, seconds
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (diff % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor(
          (diff % (1000 * 60)) / 1000
        );

        setTimeRemaining(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      }
    }, 1000);

    // Cleanup on unmount or re-render
    return () => clearInterval(intervalId);
  }, [unlockTime]);

  return (
    <div className="grid grid-cols-5 md:grid-cols-6 items-center hover:bg-white/5 py-2 px-0 xs:px-2 text-[11px] sm:text-sm">
      {/* Token symbol & image */}
      <div className="flex items-center gap-2">
        {positionData && (
          <img src={positionData.img} alt="Token" className="w-6 h-6" />
        )}
        {positionData?.symbol}
      </div>

      {/* Amount of ETH borrowed */}
      <div>
        {positionData &&
          (Math.round(positionData.amountETHBorrowed * 10000) / 10000 || '0')}
      </div>

      {/* Amount of tokens borrowed */}
      <div className='hidden md:block'>{positionData?.amountTokenBorrowed || '0'}</div>

      {/* Rewards */}
      <div>${positionData?.shareborrow || '0'}</div>

      {/* Countdown Timer (days, hours, minutes, seconds) or 'N/A' */}
      <div>
        {unlockTime ? (
          <span className="text-[8px] sm:text-sm text-white/60">
            {timeRemaining}
          </span>
        ) : (
          'N/A'
        )}
      </div>

      {/* Withdraw button (only enabled if unlocked) */}
      <div className="text-right">
        <button
          disabled={!isUnlocked}
          className={`bg-red-400/10 hover:bg-red-400/15 border  font-semibold 
            border-red-400/40 hover:border-red-400/50 rounded-sm ease-in duration-100 
            text-gray-300 hover:text-gray-100 w-16 xs:w-16 sm:w-32 py-[3px] xs:py-[4px] text-[8px] sm:text-[11px] mx-0
            ${!isUnlocked ? 'opacity-50 cursor-not-allowed' : ''}`}
          onClick={() => handleWithdrawBorrow(position)}
        >
          Close Borrow
        </button>
      </div>
    </div>
  );
}
